import { BorderColor, TagColor } from '../interface/common';

export const SignificanceType: Record<string, string> = {
  normal: 'Normal',
  important: 'Important',
  archived: 'Archived',
};
export enum SignificanceTypeValue {
  normal = 'normal',
  important = 'important',
  archived = 'archived',
}
export enum NotesEntity {
  MATTER = 'matter',
  TRANSACTION = 'transaction',
  EXPENSE = 'expense',
  COMPANY = 'company',
  PRIVATEPERSON = 'privateperson',
  PRELIMINARYINVOICE = 'preliminaryinvoice',
  MATTERREQUEST = 'matterrequest',
  ACTIVITY = 'activity',
}
export const entityFilterMap: Record<NotesEntity, string> = {
  [NotesEntity.MATTER]: 'matterId',
  [NotesEntity.TRANSACTION]: 'transactionId',
  [NotesEntity.PRELIMINARYINVOICE]: 'preliminaryInvoiceId',
  [NotesEntity.COMPANY]: 'companyId',
  [NotesEntity.PRIVATEPERSON]: 'privatePersonId',
  [NotesEntity.EXPENSE]: 'expenseId',
  [NotesEntity.MATTERREQUEST]: 'matterRequestId',
  [NotesEntity.ACTIVITY]: 'activityId',
};
export const getNoteFilterByEntity = (
  entity: NotesEntity,
  entityId: string,
): Record<string, string> => {
  const filterKey = entityFilterMap[entity];

  if (!filterKey) return {}; // default case: invalid entity

  return {
    [`${filterKey}`]: `$eq:${entityId}`,
  };
};
export const tagColorMapping: {
  [key in SignificanceTypeValue]: TagColor;
} = {
  [SignificanceTypeValue.important]: TagColor.RED,
  [SignificanceTypeValue.normal]: TagColor.YELLOW,
  [SignificanceTypeValue.archived]: TagColor.GREEN,
};

export const borderColorMapping: {
  [key in SignificanceTypeValue]: BorderColor;
} = {
  [SignificanceTypeValue.important]: BorderColor.RED,
  [SignificanceTypeValue.normal]: BorderColor.YELLOW,
  [SignificanceTypeValue.archived]: BorderColor.GREEN,
};

export const NOTE_QUERY_KEYS_TO_INVALIDATE = ['notes-list'];
